<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载Excel</el-button>
          <!-- 下载实际面积电器Excel -->
          <!-- <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelActualArea">下载实际面积电器Excel</el-button> -->
          <!-- <el-button type="text" icon="el-icon-download" size="small" plain
            @click.stop="downloadCode({ type: 2 })">下载吊顶报单通用码</el-button> -->
          <!-- <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadFinanceExcelPipeline">下载吊顶财务Excel</el-button> -->
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">报单
          </el-button>
          <!-- <el-button type="text" icon="el-icon-view" size="small" plain
            @click.stop="toViewOrder(scope.row)">查看工单</el-button> -->
          <el-button type="text" icon="el-icon-edit" size="small" plain
            @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-view" size="small"
            v-if="scope.row.engineeringOrderId &&scope.row.orderStatus !== 'WAIT_DISTRIBUTE' || !scope.row.shopId"
            plain @click.stop="viewAcceptance(scope.row)">工单</el-button>
          <el-button
            v-if=" scope.row.orderStatus !== 'WAIT_DISTRIBUTE'||scope.row.orderStatus == 'WAIT_FOR_ASSIGN'"
            type="text" icon="el-icon-service" size="small" plain
            @click.stop="handleAcceptance(scope.row)">{{scope.row.orderStatus == 'WAIT_FOR_ASSIGN' ? '指派' : '改派'}}</el-button>
          <el-button
            v-if="scope.row.orderStatus == 'COMPLETE'"
            type="text" icon="el-icon-star-on" size="small" plain
            @click.stop="handleViewEvaluation(scope.row)">评价</el-button>
          <!-- <el-button type="text" icon="el-icon-view" size="small" plain
            v-if="scope.row.deliveryOrderId && scope.row.orderStatus != 'WAIT_FOR_ASSIGN'"
            @click.stop="viewDelivery(scope.row)">提货单</el-button> -->
        </template>
        <template slot-scope="scope" slot="orderStatus">
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_DELIVERY'" type="warning">待提货</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_INSTALL'" type="warning">施工中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'INSTALLED'" type="success">已安装</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_ASSIGN'" type="warning">待指派</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_DISTRIBUTE'" type="warning">待指派</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_FOR_DELIVERY_SECOND'" type="warning">待二次提货</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'COMPLETE'" type="info">已完成</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'PARTIAL_INSTALLATION'" type="warning">部分安装</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_EVALUATED'" type="warning">待评价</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'IN_SERVICE'" type="warning">服务中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'PARTIAL_REFUND'" type="danger">部分退款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'REFUND_PAY'" type="danger">已退款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_THE_FINAL'" type="warning">待终审</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_ACCEPTED'" type="warning">待吊顶</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'UNDER_ACCEPTANCE'" type="warning">施工中</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'ACCEPTANCE_COMPLETED'" type="success">已吊顶</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'TO_BE_CONFIRMED'" type="success">待确认</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_BALANCE_PAYMENT'" type="danger">待付尾款</el-tag>
          <el-tag v-if="scope.row.orderStatus == 'WAIT_INSTALL_SECOND'" type="warning">施工中</el-tag>
        </template>
        <template slot="picUrlForm">
          <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploaded" :uploaded-images="picUrl" />
        </template>
        <template slot-scope="scope" slot="picUrl">
          <viewer :images="formmaterImage(scope.row.picUrl)">
            <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
          </viewer>
        </template>
      </avue-crud>
      <!-- 提货单弹窗 -->
      <!-- <el-dialog title="生成提货单" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="tabelObj" :rules="rules" label-width="100px" ref="tabelObj">
          <el-row>
            <el-col :span="12">
              <el-form-item label="前仓" prop="warehouseId">
                <el-select v-model="tabelObj.warehouseId" placeholder="请选择前仓">
                  <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="tabelObj.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog> -->
      <el-dialog title="生成工单" :visible.sync="dialogAcceptanceVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="superiorEr" :rules="rules" label-width="100px" ref="superiorEr">
          <el-row>
            <!-- 远程搜索工程师 -->
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="superiorEr.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelHandleAcceptance">取 消</el-button>
          <el-button type="primary" @click="confirmHandleAcceptance">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 输入框对话框 -->
      <el-dialog :title="currentDialogTitle" :visible.sync="isDialogVisible" width="30%">
        <div v-if="isInputVisible">
          <el-input v-model="inputValue" placeholder="请输入内容" style="width: 100%; margin-bottom: 10px;"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitInput">提交</el-button>
        </span>
      </el-dialog>
      <viewAcceptanceOrder :visibleAcceptanceOrder.sync="viewAcceptanceVisible" :infoDetail="infoDetail"
        :orderId="engineeringOrderId" :id="idNow" :totalPrice="totalPrice" @refresh="handleList" @close="viewAcceptanceVisible = false" />
      <!-- 报单查看全屏弹窗 -->
      <ViewDeclarationModal :visible.sync="viewDeclarationVisible" :id="currentDeclarationId" @close="handleDeclarationModalClose" />
      <!-- 报单编辑全屏弹窗 -->
      <EditDeclarationModal :visible.sync="editDeclarationVisible" :id="currentDeclarationId" @close="handleDeclarationModalClose" @success="handleDeclarationEditSuccess" />
      <!-- 评价查看全屏弹窗 -->
      <ViewEvaluationModal :visible.sync="viewEvaluationVisible" :id="currentEvaluationId" @close="handleEvaluationModalClose" />
      <!-- 绑定经营主体弹窗 -->
      <el-dialog title="请绑定经营主体" :visible.sync="businessEntityDialogVisible" width="700px" :close-on-click-modal="false">
        <div class="business-entity-dialog-content">
          <!-- 店铺信息 -->
          <el-form :model="businessEntityForm" label-width="100px" style="margin-bottom: 20px;">
            <el-form-item label="店铺名称">
              <el-input v-model="currentShopName" disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺电话">
              <el-input v-model="currentShopMobile" disabled></el-input>
            </el-form-item>
            <el-form-item label="施工地址">
              <el-input v-model="currentCustomAddress" disabled></el-input>
            </el-form-item>
            <el-form-item label="经营主体" prop="businessEntityId">
              <el-select v-model="businessEntityForm.businessEntityId" placeholder="请选择经营主体" filterable clearable style="width: 100%;">
                <el-option v-for="item in businessEntityList" :key="item.id" :label="item.entityName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="businessEntityDialogVisible = false">取消</el-button>
          <el-button type="text" @click="confirmBusinessEntityBinding" icon="el-icon-check">确定绑定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { resolveUrlPath } from "@/util/util";
import { pipelineTableOption } from "@/const/work/pipeline/merchantsOption";
import {
  getAgentList, addDeliveryOrder, getDeliveryOrder, updateDeliveryOrder, findPipeline, addPipeline, editPipeline, delPipeline,
  findPipelineAll, downloadExcelCustomsDeclaration, handleRebates, getDownloadCode, downloadFinanceExcelPipeline,
  getRootDepartmentId, putNextStep, createAcceptanceOrder, updateAcceptanceOrder
} from "@/api/work/pipeline/merchants"
import { getWarehouseList, } from "@/api/salesCloud/warehouse";
import { findUserList } from "@/api/work/projectService";
import { getBusinessEntityList, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import ImageUpload from "@/components/imageUpload/ImageUpload";
import viewAcceptanceOrder from "./components/viewAcceptanceOrder.vue";
import ViewDeclarationModal from "./components/view-declaration-modal.vue";
import EditDeclarationModal from "./components/edit-declaration-modal.vue";
import ViewEvaluationModal from "./components/view-evaluation-modal.vue";
export default {
  name: "pipeline",
  components: {
    ImageUpload,
    viewAcceptanceOrder,
    ViewDeclarationModal,
    EditDeclarationModal,
    ViewEvaluationModal
  },
  data() {
    return {
      tableOption: pipelineTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      users: [],
      agentList: [],
      totalPrice: 0,
      rules: {
        engineerId: [
          { required: true, message: "请选择工程师", trigger: "change" }
        ],
      },
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 30 //每页显示多少条
      },
      dialogVisible: false,
      viewOrderVisible: false,
      evaluateInfo: false,
      WarehouseList: [],
      downloadData: {},
      rootDepartmentId: "",
      superiors: [],
      superior: {},
      picUrl: "",
      fileList: [],
      orderId: "",
      engineeringOrderId: "",
      idNow: "",
      steps: new Map([
        [1, { label: "是否派单", value: '', hasInput: true, dialogTitle: "请输入施工员" }],
        [2, { label: "涂料已刷", value: '', hasInput: false, dialogTitle: "" }],
        [3, { label: "闭水", value: '', hasInput: true, dialogTitle: "请输入吊顶员" }],
        [4, { label: "是否审核", value: '', hasInput: false, dialogTitle: "" }],
      ]),
      inputValue: "", // 输入框的值
      isDialogVisible: false, // 控制对话框显示
      dialogAcceptanceVisible: false, // 控制框显示
      viewAcceptanceVisible: false,
      isLoading: false, // 按钮加载状态
      superiorEr: {
        engineerId: "",
        declarationId: "",
      },
      rowInfo: {},
      infoDetail: {},
      hasSetDefaultAgent: false,
      // 经营主体绑定相关
      businessEntityDialogVisible: false,
      businessEntityList: [],
      businessEntityForm: {
        businessEntityId: ''
      },
      currentShopId: null,
      currentShopName: '',
      currentShopMobile: '',
      currentCustomAddress: '',
      businessEntityLoading: false,
      // 报单查看和编辑弹窗
      viewDeclarationVisible: false,
      editDeclarationVisible: false,
      currentDeclarationId: "",
      // 评价查看弹窗
      viewEvaluationVisible: false,
      currentEvaluationId: "",
    };
  },
  created() {
    this.getAgentList();
    this.handleList();
    this.handleWarehouseList();
  },
  watch: {
    agentList(newVal) {
      if (!this.hasSetDefaultAgent && Array.isArray(newVal) && newVal.length) {
        const first = newVal[0];
        this.$nextTick(() => {
          if (this.$refs && this.$refs.crud && this.$refs.crud.searchForm) {
            if (!this.$refs.crud.searchForm.rootDepartId) {
              this.$set(this.$refs.crud.searchForm, 'rootDepartId', first.value);
              this.hasSetDefaultAgent = true;
              // 设定默认后触发一次查询，保证列表与默认代理商同步
              this.searchChange({ ...this.$refs.crud.searchForm });
            }
          }
        });
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
    // 获取当前对话框标题
    currentDialogTitle() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.dialogTitle : "";
    },
    // 判断是否需要输入框
    isInputVisible() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.hasInput : false;
    },
  },
  props: [],
  methods: {
    // 获取代理商列表
    async getAgentList() {
      const res = await getAgentList();
      if (res.code == "200") {
        this.agentList = JSON.parse(res.data);
        // 将代理商列表转换为下拉选项
        this.agentList = this.agentList.map(item => ({
          ...item,
          label: item.company,
          value: item.id,
        }));
        // 按 prop 精准定位列，避免依赖固定下标
        const idx = Array.isArray(this.tableOption.column)
          ? this.tableOption.column.findIndex(col => col && col.prop === "rootDepartId")
          : -1;
        if (idx !== -1) {
          // 使用 $set 确保响应式更新 dicData
          this.$set(this.tableOption.column[idx], "dicData", this.agentList);
        }
      }
    },
    toViewOrder(row) {
      this.viewOrderVisible = true;
      this.evaluateInfo = false;
      this.orderId = row.deliveryOrderId;
      this.idNow = row.id;
    },
    async handleClick(row) {
      const step = this.steps.get(row.step);
      // step:4为已完成的情况不允许点击
      if (row.step > 4) {
        this.$message.error("已完成，不允许点击");
        return;
      }
      if (step.hasInput) {
        // 如果需要输入框，显示对话框
        this.isDialogVisible = true;
        this.rowInfo = row;
      } else {
        // 如果不需要输入框，直接请求并进入下一步
        await this.requestStep(row, '');
        //this.nextStep();
      }
    },
    async submitInput() {
      if (this.inputValue.trim()) {
        // 保存输入的值
        // 发送请求
        await this.requestStep(this.rowInfo, this.inputValue);
        // 清理输入框并关闭对话框
        this.inputValue = "";
        this.isDialogVisible = false;
        // 进入下一步
        //this.nextStep();
      } else {
        this.$message.error("请输入有效内容");
      }
    },
    async requestStep(row, val) {
      try {
        this.isLoading = true; // 开始加载
        var step = "";
        if (row.val) {
          step = row.step + ':' + row.val + "," + val
        } else {
          step = row.step + ':' + val
        }
        const params = {
          step: step,
          id: row.id
        };
        const res = await putNextStep(params);
        if (res.code === "200") {
          this.$message.success(`步骤 ${row.stepName} 完成`);
          this.handleList();
        } else {
          this.$message.error("请求失败，请重试");
        }
      } catch (error) {
        this.$message.error("请求失败，请重试");
      } finally {
        this.isLoading = false; // 停止加载
      }
    },
    // cancel取消
    cancel() {
      this.dialogVisible = false;
      // 清空表单
      this.tabelObj = {};
    },
    // confirm生成提货单
    confirm() {
      this.$refs["tabelObj"].validate((valid) => {
        if (valid) {
          let params = this.tabelObj;
          params.status = "WAIT_FOR_DELIVERY";
          if (params.deliveryOrderId) {
            // 先通过提货单id查询getDeliveryOrder
            getDeliveryOrder(params.deliveryOrderId).then((res) => {
              if (res.code == "200") {
                let data = JSON.parse(res.data).rows[0];
                params = { ...data, ...params };
                updateDeliveryOrder(params).then((res) => {
                  if (res.code == "200") {
                    this.$message({
                      showClose: true,
                      message: "修改提货单成功",
                      type: "success",
                    });
                    this.handleList();
                    this.dialogVisible = false;
                  } else if (res.code == "24022061") {
                    // 报单商家经营主体不存在，触发绑定弹窗
                    this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
                    // 打开绑定经营主体弹窗
                    this.openBusinessEntityDialog(params.shopId, params.shopName, params.shopMobile, params.customAddress);
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "error",
                    });
                  }
                })
              }
            })
          } else {
            addDeliveryOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成提货单成功",
                  type: "success",
                });
                this.handleList();
              } else if (res.code == "24022061") {
                // 报单商家经营主体不存在，触发绑定弹窗
                this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
                // 打开绑定经营主体弹窗
                this.openBusinessEntityDialog(params.shopId, params.shopName, params.shopMobile, params.customAddress);
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.tabelObj = {};
          this.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    // handleRemote远程搜索工程师
    handleRemote(query) {
      // eslint-disable-next-line no-control-regex
      if (/[^\x00-\xff]/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (/^\d{11}$/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      }
    },
    handleWarehouseList() {
      let params = {
        page: 1,
        size: 100,
      };
      getWarehouseList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.WarehouseList = data.rows;
      });
    },
    // 生成提货单
    handleDelivery(row) {
      // 打开生成提货单弹窗
      this.dialogVisible = true;
      this.tabelObj.deliveryOrderId = row.deliveryOrderId ? row.deliveryOrderId : "";
      this.tabelObj.shopId = row.shopId;
      this.tabelObj.shopName = row.shopName;
      this.tabelObj.shopMobile = row.shopMobile;
      this.tabelObj.customAddress = row.customAddress;
      this.tabelObj.declarationId = row.id;
      // 添加rootDepartId参数传递
      if (this.$refs && this.$refs.crud && this.$refs.crud.searchForm && this.$refs.crud.searchForm.rootDepartId) {
        this.tabelObj.rootDepartId = this.$refs.crud.searchForm.rootDepartId;
      } else {
        delete this.tabelObj.rootDepartId;
      }
    },
    handleAcceptance(row) {
      this.dialogAcceptanceVisible = true;
      this.superiorEr.declarationId = row.id;
      this.superiorEr.contactsMobile = row.shopMobile;
      this.superiorEr.engineeringOrderId = row.engineeringOrderId
      this.superiorEr.type = "PIPELINE";
    },
    viewAcceptance(row) {
      this.evaluateInfo = false;
      this.viewAcceptanceVisible = true;
      this.infoDetail = row;
      this.engineeringOrderId = row.engineeringOrderId;
      this.idNow = row.id;
      this.totalPrice = row.totalPrice;
    },
    confirmHandleAcceptance() {
      this.$refs["superiorEr"].validate((valid) => {
        if (valid) {
          var params = {
            ...this.superiorEr,
          }
          if (params.engineeringOrderId) {
            const params1 = {
              id: this.superiorEr.engineeringOrderId,
              engineerId: this.superiorEr.engineerId,
              status: 'WAIT_ACCEPT'
            };
            updateAcceptanceOrder(params1).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成工单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          } else {
            createAcceptanceOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成工单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.superiorEr = {};
          this.dialogAcceptanceVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    cancelHandleAcceptance() {
      this.dialogAcceptanceVisible = false;
      this.superiorEr = {};
    },
    // 查看提货单
    viewDelivery(row) {
      // 查看
      let obj = {
        label: "吊顶提货单",
        value: "/work/eliveryOrder/ceilingView",
        query: { id: row.deliveryOrderId, type: row.type },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    // 生成商家码并显示弹窗
    downloadCode(type) {
      this.$confirm("是否确认生成通用码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const data = {
          scene: this.rootDepartmentId,
          page: type.type == 1 ? "pages/pipeline/install/install" : "pages/pipeline/customer/customer",
          width: "340",
          clientType: "JOINS_MERCHANT",
        };
        getDownloadCode(data).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            this.handleList();
          }
        });
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成通用码"
          });
        });
    },
    /**
     * @title 分类下拉框数据
     *
     **/
    handleSuperior() {
      findPipelineAll().then((res) => {
        let data = JSON.parse(res.data)
        this.superiors = data
      })
    },
    handleUploaded(url) {
      // 只支持单张图片上传
      this.picUrl = url;
      this.tableLoading = false;
    },
    formmaterImage(row) {
      let str = new Array();
      JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findPipeline(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findPipeline(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      this.downloadData = params;
      findPipeline(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      downloadExcelCustomsDeclaration(params).then((response) => {
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    // downloadExcelActualArea() {
    //   let params = this.downloadData;
    //   // 温馨提示：只会下载已提货的报单数据
    //   this.$confirm('温馨提示：只会下载已提货的报单数据', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     downloadExcelActualArea(params).then((response) => {
    //       // 提取文件名
    //       const filename = response.headers["content-disposition"].match(
    //         /filename=(.*)/
    //       )[1];
    //       // 将二进制流转为blob
    //       const blob = new Blob([response.data], {
    //         type: "application/octet-stream",
    //       });
    //       if (typeof window.navigator.msSaveBlob !== "undefined") {
    //         // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    //         window.navigator.msSaveBlob(blob, decodeURI(filename));
    //       } else {
    //         // 创建新的URL并指向File对象或者Blob对象的地址
    //         const blobURL = window.URL.createObjectURL(blob);
    //         // 创建a标签，用于跳转至下载链接
    //         const tempLink = document.createElement("a");
    //         tempLink.style.display = "none";
    //         tempLink.href = blobURL;
    //         tempLink.setAttribute("download", decodeURI(filename));
    //         // 兼容：某些浏览器不支持HTML5的download属性
    //         if (typeof tempLink.download === "undefined") {
    //           tempLink.setAttribute("target", "_blank");
    //         }
    //         // 挂载a标签
    //         document.body.appendChild(tempLink);
    //         tempLink.click();
    //         document.body.removeChild(tempLink);
    //         // 释放blob URL地址
    //         window.URL.revokeObjectURL(blobURL);
    //         this.searchChange(params);
    //       }
    //     });
    //   }).catch(() => {
    //   })
    // },
    downloadFinanceExcelPipeline() {
      let params = this.downloadData;
      // 温馨提示：只会下载已提货的报单数据
      this.$confirm('温馨提示：只会下载已提货的报单数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        downloadFinanceExcelPipeline(params).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            this.searchChange(params);
          }
        });
      }).catch(() => {
      })
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findPipeline(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // 清空表单
      this.cleanForm();
      this.$refs.crud.rowAdd();
    },
    handleView(row) {
      // 使用全屏弹窗查看报单
      this.currentDeclarationId = row.id;
      this.viewDeclarationVisible = true;
    },
    handleEdit(row) {
      // 使用全屏弹窗编辑报单
      this.currentDeclarationId = row.id;
      this.editDeclarationVisible = true;
    },
    handleViewEvaluation(row) {
      // 使用全屏弹窗查看评价，使用工程订单ID
      this.currentEvaluationId = row.engineeringOrderId;
      this.viewEvaluationVisible = true;
    },
    handleEvaluationModalClose() {
      this.viewEvaluationVisible = false;
    },
    getStep() {
      for (var i = 0; i < this.tableData.length; i++) {
        let row = this.tableData[i];
        if (row.step == null || row.step == 0) {
          row.step = 0;
        } else {
          var step1 = row.step.split(":");
          row.step = step1[0];
          var val = step1[1];
          if (val) {
            row.val = val;
          } else {
            row.val = "";
          }
        }
        row.step = Number(row.step) + 1;
        if (row.step > this.steps.size) {
          row.stepName = "已完成";
        } else {
          row.stepName = this.steps.get(row.step).label;
        }
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      }
      this.downloadData = parmas;
      findPipeline(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      })
      this.handleSuperior();
    },
    /**
     * @title cleanForm
     */
    cleanForm() {
      this.superior = {};
      this.superior.id = null;
      this.picUrl = "";
      this.fileList = [];
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.superiorId = this.superior.id;
      row.picUrl = this.picUrl;
      addPipeline(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      this.tableRow = val;
      /* this.$notify({
          showClose: true,
          message: JSON.stringify(val),
          type: 'success',
      }); */
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        })
        return
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id)
          }
          delPipeline(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.superiorId = this.superior.id
      row.picUrl = this.picUrl;
      editPipeline(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    handleRebates(row) {
      // 返利确认
      this.$confirm(`是否确认返利?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          handleRebates(row.id).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "返利成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
    },
    handleDetail(row, index) {
      this.superior = {};
      this.superior.id = row.superiorId;
      this.picUrl = row.picUrl;
      this.$refs.crud.rowView(row, index)
    },
    // 打开经营主体绑定弹窗
    openBusinessEntityDialog(shopId, shopName, shopMobile, customAddress) {
      this.currentShopId = shopId;
      this.currentShopName = shopName;
      this.currentShopMobile = shopMobile;
      this.currentCustomAddress = customAddress;
      this.businessEntityDialogVisible = true;
      this.getBusinessEntityList();
    },
    // 获取经营主体列表
    getBusinessEntityList(entityName = '') {
      this.businessEntityLoading = true;
      const params = {
        page: '1',
        size: '100', // 不分页，获取足够多的数据
        entityName: entityName
      };
      getBusinessEntityList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.businessEntityList = data.rows || [];
        })
        .finally(() => {
          this.businessEntityLoading = false;
        });
    },
    // 经营主体远程搜索
    handleBusinessEntityRemoteSearch(query) {
      this.getBusinessEntityList(query);
    },
    // 确认绑定经营主体
    confirmBusinessEntityBinding() {
      if (!this.businessEntityForm.businessEntityId) {
        this.$message.error('请选择要绑定的经营主体');
        return;
      }
      if (!this.currentShopId) {
        this.$message.error('商户信息有误，请重试');
        return;
      }
      // 调用绑定接口
      const params = [{
        shopId: this.currentShopId,
        businessEntityId: this.businessEntityForm.businessEntityId,
        shopName: this.currentShopName,
        shopMobile: this.currentShopMobile
      }];
      addShopEntityBind(params)
        .then(res => {
          if (res.code == '200') {
            this.$message.success('绑定经营主体成功');
            this.businessEntityDialogVisible = false;
            // 重置状态
            this.businessEntityForm.businessEntityId = '';
            this.currentShopId = null;
            this.currentShopName = '';
            this.currentCustomAddress = '';
            this.currentShopMobile = '';
          } else {
            this.$message.error(res.message || '绑定经营主体失败');
          }
        });
    },
    // 报单弹窗关闭处理
    handleDeclarationModalClose() {
      this.currentDeclarationId = "";
    },
    // 报单编辑成功处理
    handleDeclarationEditSuccess() {
      this.handleList();
      this.currentDeclarationId = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
::v-deep .el-table--medium td {
  padding: 0 !important;
}
::v-deep .el-table {
  font-size: 12px !important;
}
::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
::v-deep .el-table--medium th {
  padding: 0px !important;
}
::v-deep .el-table td .el-table th {
  padding: 0px !important;
}
</style>